import script from "./IncomeGuidance.vue?vue&type=script&setup=true&lang=ts"
export * from "./IncomeGuidance.vue?vue&type=script&setup=true&lang=ts"

import "./IncomeGuidance.vue?vue&type=style&index=0&id=60464e1b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60464e1b"]])

export default __exports__